import * as React from 'react'

import './ToolCard.css'

import {Card, ICardProps} from './Card'
import ExternalLink from './ExternalLink';

interface IToolCardProps extends ICardProps {
    toolId: string;

    time: string;
    participants: string;

    shortDescription?: string;
    source?: string;
}

interface IToolCardState {
    isExpanded: boolean;
}

class ToolCard extends Card<IToolCardProps,  IToolCardState> {
    public constructor(props: IToolCardProps) {
        super(props);

        this.state = {
            isExpanded: false
        };
    }

    public render() {
        const mouseDownedPrepped = this.mouseDowned.bind(this);
        const mouseUppedPrepped = this.mouseUpped.bind(this);
        const mouseMovedPrepped = this.mouseMoved.bind(this);
        const mouseLeftPrepped = this.mouseLeft.bind(this);

        return (
            <div
                className={
                    "ToolCard "
                        + this
                        .getClassModifiers()
                        .map<string>(modifier => "ToolCard--"+modifier)
                        .join(" ")
                }
                onClick={this.clicked}

                onMouseDown={mouseDownedPrepped}
                onMouseUp={mouseUppedPrepped}
                onMouseMove={mouseMovedPrepped}
                onMouseLeave={mouseLeftPrepped}

                ref={this.getCardRef()}
                >
                <div className="ToolCard__header">
                    <div className="ToolCard__name">
                        <span>{ this.props.name }<span /></span>
                    </div>
                    <div className="ToolCard__detail">
                        <div className="ToolCard__detail-box ToolCard__detail-box--left">
                            <i className="ToolCard__detail__icon material-icons">schedule</i><span>{ this.props.time }</span>
                        </div>

                        <div className="ToolCard__detail-box ToolCard__detail-box--right">
                            <i className="ToolCard__detail__icon material-icons">people</i><span>{ this.props.participants }</span>
                        </div>
                    </div>
                </div>
                <div className="ToolCard__body">
                    {this.props.shortDescription}
                </div>
                <div className="ToolCard__footer">
                    <ExternalLink sizeModifier="medium" source={this.props.source || ""} />

                    <div className="ToolCard__sub-caption">
                        MORE INFORMATION
                    </div>
                </div>
            </div>
        );
    }

    protected getClassModifiers() : string[] {
        return this.state.isExpanded ? [ "expanded" ] : [];
    }

    protected isDragPossible() : boolean {
        return !this.state.isExpanded && super.isDragPossible();
    }

    private clicked = () => {
        this.setState({
            isExpanded: !this.state.isExpanded
        });
    };
}

export default ToolCard;



// WEBPACK FOOTER //
// ./src/App/Elements/ToolCard.tsx